import { render, staticRenderFns } from "./StepContacts.vue?vue&type=template&id=2c305066&scoped=true"
import script from "./StepContacts.vue?vue&type=script&lang=js"
export * from "./StepContacts.vue?vue&type=script&lang=js"
import style0 from "./StepContacts.vue?vue&type=style&index=0&id=2c305066&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c305066",
  null
  
)

export default component.exports